<template>
  <a :href="linkMap" v-if="checkAddress" target="_blank" class="link-with-icon">
    <v-icon color="primary" small>mdi-google-maps</v-icon>
    <span>{{ text }}</span>
  </a>
</template>

<script>
export default {
  name: "linkMap",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    text: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    from: null
  }),
  computed: {
    countries: {
      get() {
        return this.$store.getters["localizationStore/countryStore/getList"];
      }
    },
    country() {
      if (!this.countries || !this.countries.length || !this.item) {
        return "";
      }
      let code = this.item.address_country_code;
      return (this.countries.find(i => i.code === code) || {}).name;
    },
    checkAddress() {
      return (
        this.country ||
        this.item.address_city ||
        this.item.address_1 ||
        this.item.address_2 ||
        this.item.address_postcode
      );
    },
    linkMap() {
      let address = [
        this.country,
        this.item.address_city,
        this.item.address_1,
        this.item.address_2,
        this.item.address_postcode
      ];
      address = address.filter(i => !!i);
      return `https://www.google.com/maps/search/${address.join(", ")}`;
    }
  },
  created() {
    this.$store.dispatch("localizationStore/countryStore/getList", {
      params: { limit: -1 }
    });
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}
span {
  margin-left: 8px;
}
</style>
